import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './app.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(ElementUI)

new Vue({
  el: '#app',
  render: h => h(App)
})

AOS.init({
  offset: 30,
  delay: 100, // values from 0 to 3000, with step 50ms
  duration: 800 // values from 0 to 3000, with step 50ms
})
